const uploadMessagePhotoUp = {
  click: 'Haga clic o arrastre la foto aquí...',
  error: 'Archivo no soportado',
  success: 'Suelte la foto aquí'
};

export default uploadMessagePhotoUp;
